export default __webpack_public_path__ + "static/cointelegraph-2abdf1b0d29dce5d73b723fbeb2c91d3.svg";